(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('HospitalizationDialogController', HospitalizationDialogController);

    HospitalizationDialogController.$inject = ['$timeout', '$scope', 'hospitalization', '$uibModalInstance',
        'Hospitalization', 'HospitalizationDischargeTo', '$state'
    ];

    function HospitalizationDialogController($timeout, $scope, hospitalization, $uibModalInstance,
                                             Hospitalization, HospitalizationDischargeTo, $state) {
        var vm = this;
        vm.hospitalization = hospitalization;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.hospitalizationdischargetos = HospitalizationDischargeTo.query();
        vm.editing = $state.current.name != "hospitalization.view";

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.hospitalization.id !== null) {
                Hospitalization.update(vm.hospitalization, onSaveSuccess, onSaveError);
            } else {
                Hospitalization.save(vm.hospitalization, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('dialysisApp:hospitalizationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.admissionDate = false;
        vm.datePickerOpenStatus.dischargeDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
